import { useContext } from "react";

import { AreaRangeChart, LoadingContent } from "../sharedComponents.index";

import PropTypes from 'prop-types';
import { TenantContext } from "../../../templates/context/TenantContext";
import { LOADING_CONTENT_TYPE } from "../LoadingContent/loading.content.constants";
import { useAnalysisViewModel } from "../../../viewModel/useAnalysysViewModel";

export function PredictionChart({ ctx, uiState }) {
  
  const { productId } = ctx || {};
  const { 
    enableAdvancedLines = true, 
    clientPlanValuesFromPastMonths = false,
    location = ""
  } = uiState || {};

  const { unit } = useContext(TenantContext);

  const vm = useAnalysisViewModel({
    productId: productId,
    shouldFetchPredictionByProduct: true,
    enableAdvancedLines: enableAdvancedLines,
    clientPlanValuesFromPastMonths: clientPlanValuesFromPastMonths,
    predictionChartLocation: location
  })

  if(vm.uiState.isLoadingProductPredictions) {
    return (
      <LoadingContent label={"Carregando predições do produto.."} type={LOADING_CONTENT_TYPE.VIEW_DATA} mode={LOADING_CONTENT_TYPE.VIEW_DATA}/>
    )
  }
 
  return (
    <div className="d-flex flex-column">
      <AreaRangeChart
        xLabels={vm?.uiState?.xLabelsPredictionChart || []}
        ranges={vm?.uiState?.ranges || []}
        lines={vm?.ctx?.defineLinesPredictionChart}
        colors={["#00BECB", "#BFBFBF", "#f58b4d", "#00BECB"]}
        unit={unit}
        lastHistoricMonthLabel={vm?.uiState?.lastHistoricMonthLabelPredictionChart ?? ""}
        legendOrderLeft="full"
      />
    </div>
  );
}

PredictionChart.propTypes = {
  ctx: PropTypes.shape(),
  uiState: PropTypes.shape()
}